import { exportToWord } from '../utils/exportToWord'; // Import the export function
import './PolicyStyles.css'; // Ensure the correct path to your CSS file

const AccidentIncidentManagementPolicy = ({ clientName, clientAddress, effectiveDate,  companyNumber, }) => {
  return (
    <div className="policy-container">
      <h3 className="policy-title">Accident & Incident Management Policy</h3>
      <p className="policy-details"><strong>Company Name:</strong> {clientName || "[Insert Company Name]"}</p>
      <p className="policy-details"><strong>Company Number:</strong> { companyNumber || "[Insert Company Number]"}</p>
      <p className="policy-details"><strong>Company Address:</strong> {clientAddress || "[Insert Company Address]"}</p>
      <p className="policy-details"><strong>Policy Effective Date:</strong> {effectiveDate || "[Insert Effective Date]"}</p>

      <h4 className="section-title">Purpose</h4>
      <p className="section-content">
        The purpose of this policy is to outline the procedures for reporting, recording, investigating, and managing accidents and incidents within the organization. This ensures that all employees are aware of the steps to take if an accident or incident occurs, and that corrective actions are taken to prevent future occurrences.
      </p>

      <h4 className="section-title">Scope</h4>
      <p className="section-content">
        This policy applies to all employees, contractors, and third-party service providers who are involved in the organization’s operations. It covers:
      </p>
      <ul>
        <li>Accidents occurring during regular operations, including vehicle accidents.</li>
        <li>Incidents involving property damage, environmental impact, or health risks.</li>
        <li>Near-miss incidents that could potentially lead to an accident.</li>
      </ul>

      <h4 className="section-title">Responsibilities</h4>
      <p className="section-content"><strong>Employees:</strong> All employees are responsible for reporting any accidents or incidents immediately to their supervisor or manager. Employees must cooperate fully in accident investigations.</p>
      <p className="section-content"><strong>Supervisors/Managers:</strong> Supervisors and managers are responsible for ensuring that accidents and incidents are reported and documented, and for initiating the investigation process.</p>
      <p className="section-content"><strong>Health & Safety Officer:</strong> The Health & Safety Officer is responsible for ensuring that the accident reporting system is in place, assisting with investigations, and ensuring compliance with regulations.</p>
      <p className="section-content"><strong>Safety Committees:</strong> Where applicable, safety committees will review accident reports, identify trends, and recommend improvements to prevent future incidents.</p>

      <h4 className="section-title">Reporting Procedures</h4>
      <h5>Immediate Action:</h5>
      <p className="section-content">
        In the event of an accident or incident, the first priority is to ensure the safety and well-being of all involved parties. Employees must:
      </p>
      <ul>
        <li>Call emergency services if necessary.</li>
        <li>Provide first aid where possible and safe to do so.</li>
        <li>Avoid disturbing the scene unless necessary for safety.</li>
      </ul>
      <h5 className="section-title">Reporting:</h5>
      <p className="section-content">Accidents and incidents must be reported to the supervisor or manager immediately. The following details should be provided:</p>
      <ul>
        <li>Date, time, and location of the accident/incident.</li>
        <li>Names of involved individuals.</li>
        <li>Description of what happened.</li>
        <li>Injuries sustained (if any).</li>
        <li>Any witnesses to the incident.</li>
      </ul>

      <h4 className="section-title">Accident/Incident Report Form</h4>
      <p className="section-content">
        A formal Accident/Incident Report Form must be completed by the employee or supervisor, outlining the key facts of the event. The form should include:
      </p>
      <ul>
        <li>Details of the incident (cause, injuries, damages).</li>
        <li>Corrective actions taken (first aid, emergency measures).</li>
        <li>Witness statements.</li>
        <li>Suggestions for future prevention.</li>
      </ul>

      <h4 className="section-title">Investigation</h4>
      <p className="section-content">
        After an accident or incident is reported, an investigation will be conducted to determine the cause(s) and identify corrective actions. The investigation process will include:
      </p>
      <ul>
        <li>Interviewing involved parties and witnesses.</li>
        <li>Inspecting the site of the accident or incident.</li>
        <li>Analyzing equipment or machinery involved.</li>
        <li>Reviewing training records and operational procedures.</li>
        <li>Identifying potential risk factors and areas for improvement.</li>
      </ul>

      <h4 className="section-title">Corrective Actions</h4>
      <p className="section-content">
        Based on the findings of the investigation, corrective actions will be implemented to prevent similar incidents from occurring. These may include:
      </p>
      <ul>
        <li>Changes to procedures or protocols.</li>
        <li>Additional training or refresher courses for employees.</li>
        <li>Equipment repairs or upgrades.</li>
        <li>Implementation of new safety measures.</li>
      </ul>

      <h4 className="section-title">Record-Keeping</h4>
      <p className="section-content">
        All accidents and incidents must be documented in the organization’s Accident/Incident Log. This record must include:
      </p>
      <ul>
        <li>Date and details of the incident.</li>
        <li>The names of the involved individuals.</li>
        <li>The corrective actions taken.</li>
      </ul>
      <p>
        Reports and investigations will be kept on file for a minimum of 3 years. The Health & Safety Officer will monitor incident trends and report to senior management on a quarterly basis.
      </p>

      <h4 className="section-title">Review and Monitoring</h4>
      <p className="section-content">
        This policy and the organization’s approach to accident and incident management will be reviewed annually. The review will include:
      </p>
      <ul>
        <li>Analyzing accident and incident reports to identify any recurring issues or patterns.</li>
        <li>Ensuring that corrective actions are implemented and effective.</li>
        <li>Consulting with employees for feedback and suggestions for improving safety practices.</li>
      </ul>

      <h4 className="section-title">Conclusion</h4>
      <p className="section-content">
        The organization is committed to providing a safe work environment for all employees and reducing the risk of accidents and incidents. By following this policy, we aim to ensure that accidents are managed effectively, and that corrective actions are taken to improve safety and prevent future occurrences.
      </p>

      <h4 className="section-title">Employee Acknowledgment and Signature</h4>
      <p>I have read, understood, and agree to comply with the Accident & Incident Management Policy. I understand my responsibilities for reporting all accidents and incidents, and for cooperating with any resulting investigations.</p>
      <p>Employee Name: _________________________</p>
      <p>Employee Signature: _________________________</p>
      <p>Date: _________________________</p>

      <h4 className="section-title">Management Approval and Signature</h4>
      <p>This policy has been approved by senior management and is hereby in effect.</p>
      <p>Manager/Officer Name: _________________________</p>
      <p>Title: _________________________</p>
      <p>Signature: _________________________</p>
      <p>Date: _________________________</p>
    </div>
  );
};

export default AccidentIncidentManagementPolicy;

